var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65817 15.3417L13.6748 11.325C13.9899 11.0118 14.1669 10.5859 14.1665 10.1417V2.49999C14.1665 1.57952 13.4203 0.833328 12.4998 0.833328H3.33317C2.4127 0.833328 1.6665 1.57952 1.6665 2.49999V14.1667C1.6665 15.0871 2.4127 15.8333 3.33317 15.8333H8.47484C8.91904 15.8337 9.34501 15.6567 9.65817 15.3417ZM8.33317 10.8333C8.33317 10.3731 8.70627 9.99999 9.1665 9.99999H12.6498L8.33317 14.3167V10.8333ZM15.8332 4.16666V15.8333C15.8332 16.7538 15.087 17.5 14.1665 17.5H4.99984C4.99984 18.4205 5.74603 19.1667 6.6665 19.1667H14.1665C16.0075 19.1667 17.4998 17.6743 17.4998 15.8333V5.83333C17.4998 4.91285 16.7536 4.16666 15.8332 4.16666Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocuments);
export default __webpack_public_path__ + "static/media/icon-documents.3e3d7fc8.svg";
export { ForwardRef as ReactComponent };